exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bluebar{\r\n    padding-left: 5%;\r\n    background: #e2e4e5;\r\n    color: black;\r\n}\r\n\r\n.link-sair{\r\n    width: 8%; \r\n    float:left;   \r\n}\r\n\r\n.user-name{\r\n    width: 73%;\r\n    float:left;\r\n}\r\n\r\n.user-name p{\r\n    padding-top: 7px;\r\n}\r\n\r\n.upper-right{\r\n    margin-top: 8px;\r\n    /* color: white; */\r\n    width: 25%;\r\n}\r\n\r\n.cor-valia{\r\n    background-color: #09559f;\r\n}\r\n\r\nimg{\r\n    height: 66px;\r\n    float: right;\r\n}\r\n\r\n.navbar-nav > li > a{\r\n    color:black;\r\n}\r\n\r\n.navbar-nav > li.open > a.dropdown-toggle{\r\n    background-color: #09559f;\r\n    color:#ffffff;\r\n}\r\n\r\n.navbar-nav > li >a:hover{\r\n    color:darkgray;\r\n}\r\n.titulo{\r\n    display: table;\r\n    float: left;   \r\n}\r\n\r\nh3{\r\n    color: white;   \r\n    display: table;\r\n    margin-bottom: -2px;\r\n}\r\n\r\n.versao{\r\n    font-size: 0.7em;\r\n    color: #8a9195;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/navegacao/menu/menu.component.css
// module id = ../../../../../src/app/navegacao/menu/menu.component.css
// module chunks = 1